import React, { useContext } from 'react';
import { mergeStyles } from 'wix-rich-content-common';
import { s as styles } from '../giphy-viewer-155fbabc.js';
import { RicosContext } from 'ricos-context';
import '../style-inject.es-746bb8ed.js';

const GiphyViewer = (props) => {
  const { theme } = useContext(RicosContext);
  const Styles = mergeStyles({ styles, theme });
  const {
    componentData: { original }
  } = props;
  if (!original.mp4 && !original.gif) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { "data-hook": "giphyPlayer" }, original.mp4 ? (
    // video should be treated as an noninteractive git element
    /* eslint-disable jsx-a11y/no-redundant-roles, jsx-a11y/no-interactive-element-to-noninteractive-role*/
    /* @__PURE__ */ React.createElement(
      "video",
      {
        role: "img",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        "aria-label": "gif",
        className: Styles.giphy_player,
        src: original.mp4
      }
    )
  ) : /* @__PURE__ */ React.createElement(
    "img",
    {
      role: "img",
      "aria-label": "gif",
      className: Styles.giphy_player,
      src: original.gif,
      alt: "gif"
    }
  ));
};

export { GiphyViewer as default };
//# sourceMappingURL=giphy-viewer.js.map
